import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// actions
import { getVariables } from "../../../../store/variables/actions";

//i18n
import { withTranslation } from "react-i18next";
import { getMessages } from "../../../../store/operator/actions";

const FilterDate = ({ t }) => {
  const { data } = useSelector((state) => state.Variables);
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [variables, setVariables] = useState(false);
  
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    dispatch(getVariables("filter_time"));
  }, []);

  const handleUpdateDate = (option) => {
    let timeInHour = 1;
    switch (option.unit) {
      case "day":
        timeInHour = 24;
        break;
      case "week":
        timeInHour = 168;
        break;
      case "month":
        timeInHour = 720;
        break;
      default:
        break;
    }
    let interval = option.value * timeInHour;
    option && dispatch(getMessages(null, interval));
  };
  const getPeriod = (option) =>
    `${option.value} ${t(option.value > 1 ? option.unit + "s" : option.unit)}`;

  useEffect(() => {
    if (data?.filter_time) {
      let i = [];
      try {
        i = JSON.parse(data?.filter_time);
      } catch (error) {
        console.error("JSON parsing error", error);
      }
      setVariables(i);
    }
  }, [data]);

  return (
    <>
      <Dropdown
        className="d-inline-flex"
        toggle={toggleDropdown}
        isOpen={isOpen}
        nav={false}
        a11y={false}
      >
        <DropdownToggle className="active-btn ml-2" style={{ border: "none" }}>
          <i
            className="bx bx-calendar active-btn"
            style={{ color: "#74788D" }}
          />
        </DropdownToggle>
        <DropdownMenu right>
          {variables.length > 0 ? (
            variables.map((child, key) => (
              <DropdownItem
                key={key}
                onClick={() => {
                  handleUpdateDate(child);
                }}
              >
                {getPeriod(child)}
              </DropdownItem>
            ))
          ) : (
            <DropdownItem
              onClick={() => {
                handleUpdateDate({ value: 24, unit: "hour" });
              }}
            >
              {`24 ${t("hours")}`}
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};
export default withTranslation()(FilterDate);
